<template>
  <div class="play-menu">
    <div class="table-header">
      <span>选集</span>
      <span class="menu-all" @click="showAll"><span>VIP会员子腾学堂全场免费观看</span><img src="@/assets/icon_jump.png"></span>
    </div>
    <div ref="menu" :swipeable="true" class="table-content">
      <div id="menu" class="menu">
        <template v-for="(item, key) in videos">
          <div :key="key" @click="clickHandle(key)" :class="['item', item.id == videoInfo.id?'play':'']">
            <div class="item-title">
              <lottie v-if="item.id == videoInfo.id" class="play-directive" :options="animOptions" :height="20" :width="20" />
              <span>第{{ key+1 }}集</span>
              <template v-if="item.tryseetime == 0">
                <span class="vip-tag">{{ paytag }}</span>
              </template>
            </div>
            <div class="item-content">
              {{ substring(albumType == 0 ? item.videoname : item.track_title, 8, true) }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'vue-lottie';
import * as playAnimation from "@/assets/animation-icon/play.json";
import { substring } from '@/utils/index'

export default {
  name: 'PlayMenu',
  components: {
    lottie
  },
  props: {
    albumType: { // 专辑类型 0 视频 1 音频
      type: Number,
      default: 0
    },
    videos: {
      type: Array,
      default: function() {
        return []
      }
    },
    videoInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isPay: {
      type: Boolean,
      default: false
    },
    paytag: {
      type: String,
      default: 'VIP'
    }
  },
  data () {
    return {
      activeTab: 'menu',
      isinner: false,
      animOptions: { animationData: playAnimation }
    }
  },
  watch: {
    videoInfo(){
      if(!this.isinner){
        this.scrollItem()
      }
      this.isinner = false
    }
  },
  methods: {
    clickHandle(key){
      this.isinner = true
      this.$emit('click', key)
    },
    showAll(){
      this.$emit('showall')
    },
    scrollItem() {
      let i = 0
      for(let key in this.videos){
        if(this.videos[key].id == this.videoInfo.id){
          i = key;
          break;
        }
      }
      const left = this.$refs.menu.children[0].children[parseInt(i)].offsetLeft
      this.$refs.menu.scrollTo(left - 20, 0)
    },
    substring
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.play-menu{
  position: sticky;
  top: -1px;
  z-index: 2;
  flex: 1;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 10px 0 0 0;
  .table-header{
    background-color: #fff;
    color: #333;
    font-size: 16px;
    font-weight:bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 0 16px;
    .menu-all{
      font-size: 13px;
      color: #666;
      font-weight: 100;
      img{
        width: 16px;
        display: inline-block;
        vertical-align: sub;
      }
    }
  }
  .table-content{
    text-align: left;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    .menu{
      display: flex;
      padding: 10px 16px;
      &::-webkit-scrollbar{
        display: none;
      }
      .item{
        flex-basis: 120px;
        flex-shrink: 0;

        font-size: 16px;
        padding: 6px 8px;
        align-items: center;
        border: 1px solid #FFEDD4;
        border-radius: 8px;
        margin-right: 12px;
        .item-title{
          color: #333;
          margin-bottom: 3px;
          position: relative;
          .vip-tag{
            position: absolute;
            top: -7px;
            right: -9px;
            background: linear-gradient(90deg, #F7DDB8 0%, #F3BB6F 100%);
            border-radius: 0px 8px 0px 8px;
            padding: 1px 6px;
            font-size: 12px;
          }
        }
        .item-content{
          color: #666666;
          font-size: 12px;
        }
        .play-directive{
          margin-right: 3px;
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
      .play{
        border-color: #FF6767;
        .item-title{
          color: #FF6767;
          .vip-tag{
            color: #fff;
            background: #FF6767;
          }
        }
        .item-content{
          color: #FF6767;
        }
      }
    }
  }
}
</style>
